import useRole from 'components/GenericsHooks/useRoles';
import authFetch from '../../helpers/requests';
import {EditingOptions} from '../grid-dx/types';
import useGetToken from './useGetToken';

function useUpdate(url: string) {
  const token = useGetToken();
  return async (editingOptions: EditingOptions) => {
    try {
      const response = await authFetch(
        `${url}`,
        {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json; charset=utf-8',
          },
          body: JSON.stringify(JSON.stringify(editingOptions.changed)),
        },
        token,
      );
      return response;
    } catch (e) {
      return e;
    }
  };
}

export function useUpdateWithPDF(url: string) {
  const token = useGetToken();
  const role = useRole();
  return async (editingOptions: EditingOptions) => {
    let options = new URLSearchParams();
    options.append('values', JSON.stringify(editingOptions.changed));
    var formData = new FormData();
    if (editingOptions.changed.files) {
      formData.append('pdf', editingOptions.changed.files[0]);
    }
    try {
      const response = await authFetch(
        `${url}?${options}&role=${role}`,
        {
          method: 'PUT',
          body: formData,
        },
        token,
      );
      return response;
    } catch (e) {
      console.error(e); // que hacemos??
    }
  };
}
export default useUpdate;
